import Vue from "vue";
import VueRouter from "vue-router";
import merchantDomains from "../config/domain.json"
import store from "@/store";
import MerchantService from "@/services/MerchantService.js";
import BranchService from "@/services/BranchService.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    beforeEnter() {
      window.location.replace("https://www.rush.ph/");
    }
  },
  // Main Router
  {
    name: "AppPaymentSuccess",
    path: "/app/payment/success",
    component: () => import("../views/app/PaymentSuccess.vue"),
    meta: {
      isFullScreen: true
    }
  },
  {
    name: "AppPaymentFailed",
    path: "/app/payment/failed",
    component: () => import("../views/app/PaymentFailed.vue"),
    meta: {
      isFullScreen: true
    }
  },
  {
    path: "/:subdomain",
    // name: 'Index',
    component: () => import("../views/Index.vue"),
    children: [
      {
        path: "",
        name: "Home",
        component: () => import("../views/Home.vue")
      },
      {
        path: "/:subdomain/brands/:uuid",
        name: "Brands",
        component: () => import("../views/brands/Index.vue"),
        props: true
      },
      {
        path: "/:subdomain/category/:uuid/:id",
        name: "Category",
        component: () => import("../views/category/Index.vue"),
        props: true
      },
      {
        path: "/:subdomain/store/:id/:productUuid?",
        name: "Store",
        component: () => import("../views/store/Index.vue"),
        props: true,
        beforeEnter:async (to, from, next) => {
          const subdomain = to.params.subdomain;
          const branch=to.params.id.split("&")[0];
          try{
            let request = {
              subdomain: subdomain
            };
            let response=await MerchantService.getCustomerPortalToken(request);
            request = {
              header: {
                "X-Merchant-Token": response.token,
              },
              is_public: true,
              payload: {
                branch_uuid: branch,
              },
            };
            response = await BranchService.getSpecificBranch(request);
            if (!response.visibility ||!response.brand_visibility) {
             throw("error");
            }
            next();
          }catch{
            next(subdomain + '/404');
          }
        },
      },
      {
        path: "/:subdomain/cart",
        name: "Cart",
        component: () => import("../views/cart/Index.vue")
      },
      {
        path: "/:subdomain/checkout",
        name: "Checkout",
        component: () => import("../views/checkout/Index.vue")
      },
      {
        path: "/:subdomain/checkout/card/details/",
        name: "CardDetails",
        component: () => import("../views/checkout/CardDetails.vue"),
        meta: {
          isFullScreen: true
        },
        props: true
      },
      {
        path: "/:subdomain/checkout/card/payment",
        name: "CardPayment",
        component: () => import("../views/checkout/CardPayment.vue"),
        meta: {
          isFullScreen: true,
          hideMap: true
        }
      },
      {
        path: "/:subdomain/checkout/payment/success",
        name: "PaymentSuccess",
        component: () => import("../views/checkout/PaymentSuccess.vue"),
        meta: {
          isFullScreen: true
        }
      },
      {
        path: "/:subdomain/checkout/payment/failed",
        name: "PaymentFailed",
        component: () => import("../views/checkout/PaymentFailed.vue"),
        meta: {
          isFullScreen: true
        }
      },
      {
        path: "/:subdomain/checkout/:paymongo_type/details/",
        name: "PayMongoDetails",
        component: () => import("../views/checkout/PayMongoDetails.vue"),
        meta: {
          isFullScreen: true
        },
        props: true
      },
      {
        path: "/:subdomain/checkout/:paymongo_type/payment",
        name: "PayMongoPayment",
        component: () => import("../views/checkout/PayMongoPayment.vue"),
        meta: {
          isFullScreen: true,
          hideMap: true
        }
      },
      {
        path: "/:subdomain/my-profile",
        name: "Profile",
        component: () => import("../views/profile/Index.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/:subdomain/orders",
        name: "Orders",
        redirect: "orders/upcoming",
        component: () => import("../views/orders/Index.vue"),
        children: [
          {
            path: "upcoming",
            name: "UpcomingOrders",
            component: () => import("../components/orders/UpcomingOrders.vue"),
            meta: {
              requiresAuth: true
            }
          },
          {
            path: "past",
            name: "PastOrders",
            component: () => import("../components/orders/PastOrders.vue"),
            meta: {
              requiresAuth: true
            }
          },
          {
            path: ":id",
            name: "OrderDetails",
            component: () => import("../components/orders/OrderDetails.vue"),
            props: true
          },
          {
            path: ":id/:uuid",
            name: "Individual",
            component: () => import("../components/orders/IndividualOrder.vue"),
            props: true
          }
        ]
      },
      {
        path: "/:subdomain/my-points",
        name: "MyPoints",
        component: () => import("../views/points/Index"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/:subdomain/rewards/:id",
        name: "RewardDetails",
        component: () => import("../components/rewards/RewardDetails.vue"),
        props: true,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/:subdomain/transaction-history",
        name: "TransactionHistory",
        component: () => import("../views/transactions/Index.vue"),
        meta: {
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          const subdomain = to.params.subdomain;
          if (store.getters['merchant/getPointsView']) {
            store.commit("transactions/SET_MAX_PAGE", 0);
            store.commit("transactions/SET_CURRENT_PAGE", 0);
            next();
          } else {
            next(subdomain + '/404');
          }
        },
      },
      {
        path: "/:subdomain/upload-receipt",
        name: "UploadReceipt",
        component: () => import("../views/upload-receipt/Index"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/:subdomain/upload-receipt-success",
        name: "UploadReceiptSuccess",
        component: () => import("../views/upload-receipt/Success"),
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  // Routing for Anything Related to Authentication (Login, Register, Forgot PIN)
  {
    path: "/:subdomain/login",
    name: "Login",
    component: () => import("../views/authentication/Index.vue"),
  },
  {
    path: "/:subdomain/signup",
    name: "Signup",
    component: () => import("../views/authentication/Index.vue"),
  },
  {
    path: "/:subdomain/forgot-password",
    name: "Forgot",
    component: () => import("../views/authentication/Index.vue"),
  },
  {
    path: "/:subdomain/terms-of-use",
    name: 'TermsOfUse',
    component: () => import("../views/TermsOfUse.vue")
  },
  {
    path: "/:subdomain/privacy-policy",
    name: 'PrivacyPolicy',
    component: () => import("../views/PrivacyPolicy.vue")
  },
  {
    path: "/:subdomain/maintenance",
    name: "Maintenance",
    component: () => import("../views/Maintenance")
  },
  {
    path: "/:subdomain/404",
    name: "subdomain-404",
    component: () => import("../views/404")
  },
  {
    path: "*",
    name: "404",
    component: () => import("../views/404")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const subpath = merchantDomains[location.hostname];
  const subdomain = to.params.subdomain;

  // If location.hostname is a custom domain, Rewrire subpath.
  if (subpath) {
    const rgxp = new RegExp("^/" + subpath);
    if (!to.path.match(rgxp)) next({ path: "/" + subpath + "/" });
  }
  // Else If subdomain is included on merchants with custom domains, redirect to custom domain.
  else if (subdomain) {
    const subdomainLowerCase = subdomain.toLowerCase();
    const merchantDomainsLowerCase = Object.values(merchantDomains).map(v => v.toLowerCase());

    if (merchantDomainsLowerCase.includes(subdomainLowerCase)) {
      const domain = Object.keys(merchantDomains).find(domain => merchantDomains[domain].toLowerCase() === subdomainLowerCase);
      const subpath = merchantDomains[domain];
      window.location.replace(`https://${domain}/${subpath}`);
    }
  }

  if (to.matched.some(record => record.meta.isFullScreen))
    store.commit("estore/SET_IS_FULL_SCREEN", true)
  else
    store.commit("estore/SET_IS_FULL_SCREEN", false);

  if (to.matched.some(record => record.meta.hideMap))
    store.commit("estore/SET_HIDE_MAP", true);
  else
    store.commit("estore/SET_HIDE_MAP", false);

  next();
});

export default router;
